import { Grid, TextField, InputAdornment, IconButton, Paper, List, ListItem, Checkbox, ListItemText , Skeleton, Typography, Button, Box } from "@mui/material";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { SearchedProduct, VariationPayloadRequest, variationPayloadInitialValue, SearchedNonVariationProductsWithPagination, VariationDetailsItem, VariationDetailsItemType, ProductVariationRequest, VariationDataType, VariationTypeRequest } from "../../../interfaces/productVariationInterface";
import EditVariation from "../EditVariation";
import SearchIcon from "@mui/icons-material/Search";
import { useAppSelector } from "../../../redux/hooks";
import { LIST_LIMIT } from "../../../constants/constants";
import lazyTypingUtils from "../../../utils/lazyTypingUtils";
import ProductVariationApi from "../services/productVariationService";
import { ROUTES } from "../../../constants/routes";
import HeaderTitle from "../../common/HeaderTitle";
import Utility from "../../../utils/Utility";
import CloseIcon from "@mui/icons-material/Close";
import SimpleReactValidator from "simple-react-validator";
import ConfirmationModal from "../../common/ConfirmationModal";
import CommonButton from "../../common/Button";
import { use } from "i18next";

const AddVariation = (props: any) => {

    const { showSnackbar , handleLoader } = props;
    const [t] = useTranslation();
    const [searchedProducts, setSearchedProducts] = useState<SearchedProduct[]>([]);
    const [showDropdown, setShowDropdown] = useState(true);
    const productListCurrentPage = useAppSelector((state: any) => state?.common?.productList);
    const perPageLimit = useAppSelector((state) => state.common.perPageLimit);
    const [currentPage, setCurrentPage] = useState(productListCurrentPage?.currentPage ?? 1);
    const [limit, setLimit] = useState(!perPageLimit ? LIST_LIMIT.BULK_PRODUCT_LIST : perPageLimit);
    const [isSearchChange, setIsSearchChange] = useState<boolean>(false);
    const [search, setSearch] = useState<string>("");
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [productVariationPayload, setProductVariationPayload] = useState<VariationPayloadRequest>(variationPayloadInitialValue);
    const [previousProducts,setPreviousProducts] = useState<VariationDetailsItem[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<VariationDetailsItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchSkeleton, setSearchSkeleton] = useState(false);
    const [showSkeleton,setShowSkeleton] = useState(true);
    const currentVariationGroupId: number = useLocation().state?.variationGroupId;
    const currentProduct: VariationDetailsItem = useLocation().state?.currentProduct;
    const [isEditMode, setIsEditMode] = useState<boolean>(currentVariationGroupId !== undefined);
    const [isPreviousProductsLoading,setIsPreviousProductsLoading] = useState(true);
    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: boolean }>({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [missingCombinationsModalOpen, setMissingCombinationsModalOpen] = useState(false);
    const [missingCombinationsList, setMissingCombinationsList] = useState<any[]>([]);
    const initialVariationTypes : VariationDataType[] = [
        { name: "カラー・柄", checked: false, type: "Radio Button", isCustom: false, isEditing: false },
        { name: "サイズ", checked: false, type: "Radio Button", isCustom: false, isEditing: false },
    ];
    const [variations, setVariations] = useState<VariationDataType[]>(initialVariationTypes);
    const [checkedVariationType, setCheckedVariationType] = useState<string[]>([]);
    const [editModeInitialRender,setEditModeInitialRender] = useState(false);
    const [completedDataSet, setCompletedDataSet] = useState<any[]>([]);
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;
    const isSuperAdminDemoSeller = useAppSelector((state) => state.common.superAdminDemoSeller) ?? false;



    const navigate = useNavigate();
    const handleProductsDetailsSearch = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { value } = e.target;
        setIsSearchChange(true);
        setSearch(value);
        setShowDropdown(true);
        setSearchSkeleton(true);
    };


    
    const [, forceUpdate] = useState(0);
    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate: () => forceUpdate((n) => n + 1) },
            className: "text-danger",
            messages: {
                required: t("required.this_field_cannot_be_empty"),
            },
            validators: {
                maxChar15Validation: {
                    message: t("product_variation_list.max_char_input_field_validation", { size: 15 }).toString(),
                    rule: (value: string, params: number) => {
                        return value.length <= params;
                    },
                },
                maxChar50Validation: {
                    message: t("product_variation_list.max_char_input_field_validation", { size: 50 }).toString(),
                    rule: (value: string, params: number) => {
                        return value.length <= params;
                    },
                }
            }
        })
    );
    const onsearchApicall = () => {
        if (isSearchChange) {
            productData(currentPage, limit);
        }
    };
    useEffect(()=> {
        setShowSkeleton(isPreviousProductsLoading && isEditMode);
    },[isPreviousProductsLoading,isEditMode]);


    useEffect(()=>{
        if(currentProduct ){
            setShowSkeleton(false);
            setSelectedProducts([...selectedProducts, currentProduct]);
            setProductVariationPayload((prev) => {

                return {
                    ...prev,
                    productVariations : [...prev.productVariations, 
                        {
                            cainzProductCode : currentProduct.cainzProductCode,
                            postingStatus : 1,
                            variations : []
                        }]
                };
                
            });
            if(currentVariationGroupId){
                setPreviousProducts([...previousProducts,currentProduct]);
            }
        }
    },[]);

    
    

    useEffect(() => {
        setIsEditMode(currentVariationGroupId !== undefined);
    }, [isEditMode, currentVariationGroupId]);

    const propItem = [
        onsearchApicall, search
    ];
    lazyTypingUtils(propItem);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowDropdown(false);
                setIsSearchChange(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    /**
     * Fetches paginated product variation data from the API.
     *
     * @param {number} currentPage - The current page number to fetch.
     * @param {number} limit - The number of items per page.
     *
     * This function resets the search state, constructs the API call,
     * and updates the products, pagination limit, and current page in the state.
     * On failure, it displays an error message using a snackbar.
     */
    const productData = (currentPage: number, limit: number) => {
        setSearchSkeleton(true);
        setIsSearchChange(false);
        const payload = {};
        const isHitDummyURL = false;
        new ProductVariationApi(payload, isHitDummyURL)
            .searchNonVariationProducts(currentPage, search.trim(), limit)
            .then((res: SearchedNonVariationProductsWithPagination) => {
                setSearchedProducts(res?.searchedProducts);
                setLimit(limit);
                setCurrentPage(currentPage);
                setSearchSkeleton(false);
            })
            .catch((err) => {
                showSnackbar(err?.message, false);
                setSearchSkeleton(false);
            });
    };

    // This effect initializes the payload with previous products data
    // It should only run when previousProducts changes and has items
    useEffect(() => {
        // Skip if no previous products
        if (!previousProducts || previousProducts.length === 0) return;
        
        // Create a new payload based on previous products
        setProductVariationPayload((prev) => {
            // Create a deep copy to avoid reference issues
            const newPayload = JSON.parse(JSON.stringify(prev));
            
            // Map previous products to payload format
            newPayload.productVariations = previousProducts.map((product, index) => {
                // Check if this product already exists in the payload
                const existingProduct = prev.productVariations.find(
                    p => p.cainzProductCode === product.cainzProductCode
                );
                
                // If it exists, preserve its data
                if (existingProduct) {
                    return {
                        ...existingProduct,
                        postingStatus: 1,
                        variations: product.variationTypes.map((variation, idx) => ({
                            variationType: variation.variationType,
                            variationValue: variation.variationValue,
                            displayType: variation.displayType,
                            displayOrder: index + 1
                        }))
                    };
                }
                
                // Otherwise create a new product entry
                return {
                    cainzProductCode: product.cainzProductCode,
                    postingStatus: 1,
                    variations: product.variationTypes.map((variation, idx) => ({
                        variationType: variation.variationType,
                        variationValue: variation.variationValue,
                        displayType: variation.displayType,
                        displayOrder: index + 1
                    }))
                };
            });
            
            // Set the face product code to the first product if available
            if (previousProducts.length > 0 && previousProducts[0].cainzProductCode) {
                newPayload.faceProductCode = previousProducts[0].cainzProductCode;
            }
            
            return newPayload;
        });

        
    }, [previousProducts]);  

    // useEffect(() => {
    //     if (completedDataSet.length > 0 && previousProducts.length === 0) {
    //         const payload = convertToVariationPayloadRequest(completedDataSet);
    //         if (payload) {
    //             setProductVariationPayload(payload);
    //         }
    //     }
    // }, [completedDataSet, previousProducts]);

    useEffect(() => {
        clickedVariationDetailsApi();
    },[]);

    /**
 * Converts an array of product variations into a VariationPayloadRequest format
 * @param inputArray The array to convert
 * @returns VariationPayloadRequest object
 */
    const  convertToVariationPayloadRequest = (inputArray?: any[]): VariationPayloadRequest =>  {
        if (!inputArray || inputArray.length === 0) {
            return {
                faceProductCode: "",
                productVariations: []
            } ;
        }

        // Extract the common prefix for faceProductCode

        const firstIndex = inputArray.findIndex((item)=> item.postingStatus !== 9);
        
        const isAllDeleted = inputArray.every((item) => item.postingStatus === 9);

        
        const faceProductCode =isAllDeleted? inputArray[0]?.cainzProductCode: inputArray[firstIndex]?.cainzProductCode;


        // Map each item to ProductVariationRequest format
        const productVariations: ProductVariationRequest[] = inputArray.map((item,productIndex) => {
            // Map variations to include required displayType and displayOrder
            const variationsData: VariationTypeRequest[] = item?.variations?.map((variation: any, varIndex: number) => {
                // displayType according to variation type
                const indexValue = variations?.findIndex((v) => v.name === variation?.variationType);
                const isListDropDown = variations?.[indexValue]?.checked && variations?.[indexValue]?.type === "List Drop-down";
                return {
                    variationType: variation.variationType,
                    variationValue: variation.variationValue,
                    displayType: item.postingStatus !==9 ? isListDropDown ? "4" : "3" : variation?.displayType, 
                    displayOrder: productIndex + 1  // Use index+1 for display order
                };
            });

            return {
                cainzProductCode: item.cainzProductCode,
                postingStatus: item.postingStatus,
                variations: variationsData
            };
        });

        return {
            faceProductCode: faceProductCode,
            productVariations: productVariations
        };
    };

    const refractorPayload = (productVariationPayload : VariationPayloadRequest) => {
        // Create a deep copy to avoid modifying the original
        const payload : VariationPayloadRequest= JSON.parse(JSON.stringify(productVariationPayload));
        
        // Filter out products with no variations or marked for deletion
        const validProducts = payload.productVariations.filter(product => 
            product && 
            product.postingStatus !== 9 && 
            product.variations && 
            Array.isArray(product.variations) && 
            product.variations.length > 0
        );
        
        // Set the face product code to the first valid product
        if (validProducts.length > 0) {
            payload.faceProductCode = validProducts[0].cainzProductCode;
        }
        
        // Convert string values to numbers where needed
        payload.productVariations = payload.productVariations.map((product,variationIdx) => {
            if (!product) return product;
            
            return {
                ...product,
                postingStatus: Number(product.postingStatus),
                variations: Array.isArray(product.variations) ? product.variations.map((variation) => {
                    if (!variation) return variation;
                    
                    return {
                        ...variation,
                        variationValue: variation.variationValue?.trim().replace(/\s+/g, " "),
                        displayOrder: variationIdx + 1
                    };
                }) : []
            };
        });
      
        return payload;
    };

    const addNewProductVariationApi = () => {
        setLoading(true);
        handleLoader(true);
        // const payload = normalizeVariationValues(refractorPayload(productVariationPayload));
        const payload = normalizeVariationValues(refractorPayload(convertToVariationPayloadRequest(completedDataSet)));
        if (!payload) {
            handleLoader(false);
            setLoading(false);
            return;
        }
        const isHitDummyURL = false;
        new ProductVariationApi(payload, isHitDummyURL)
            .addProductVariation()
            .then((res: any) => {
                showSnackbar(res, true);
                handleLoader(false);
                navigate(ROUTES.PRODUCT_VARIATION_LIST);
                setLoading(false);
            }).catch((err) => {
                handleLoader(false);
                showSnackbar(err.message, false);
                setLoading(false);
            });
    };

    const clickedVariationDetailsApi = () => {
        const payload = {};
        const isHitDummyURL = false;
        setIsPreviousProductsLoading(true);
        if(currentVariationGroupId){
            new ProductVariationApi(payload, isHitDummyURL)
                .variationDetails(currentVariationGroupId)
                .then((res: VariationDetailsItemType) => {
                    const fetchedProducts = res.variationDetailsLogs;
                    setSelectedProducts(fetchedProducts);
                    setPreviousProducts(fetchedProducts);
                    setIsPreviousProductsLoading(false);
                }).catch((err) => {
                    showSnackbar(err.message, false);
                });
        }
    };

    const editProductVariationApi = (productVariationPayload:any) => {
        setLoading(true);
        handleLoader(true);
        const payload = productVariationPayload;
        const isHitDummyURL = false;
        new ProductVariationApi(payload, isHitDummyURL)
            .editProductVariation(currentVariationGroupId)
            .then((res: any) => {
                showSnackbar(res, true);
                handleLoader(false);
                navigate(ROUTES.PRODUCT_VARIATION_LIST);
                setLoading(false);
            }).catch((err) => {
                handleLoader(false);
                showSnackbar(err.message, false);
                setLoading(false);
            });

    };

    const normalizeVariationValues = (payload: VariationPayloadRequest): VariationPayloadRequest => {
        const variationTypeValueMap = new Map<string, string>();
        
        const normalizeKey = (type: string, value: string): string => {
            return type.normalize("NFKC") + "::" + value.normalize("NFKC").toLowerCase();
        };
        
        for (const product of payload.productVariations) {
            for (const variation of product.variations) {
                const key = normalizeKey(variation.variationType, variation.variationValue);
                
                if (!variationTypeValueMap.has(key)) {
                    variationTypeValueMap.set(key, variation.variationValue);
                }
                
                variation.variationValue = variationTypeValueMap.get(key)!;
            }
        }
        return payload;
    };

    const saveButtonClickhandler = () => {
        if (completedDataSet.length === 0) {
            return;
        }
        // productVariationPayload.faceProductCode = productVariationPayload.productVariations[0].cainzProductCode;
        // --- Combination validation start ---
        const productVariationPayload = convertToVariationPayloadRequest(completedDataSet);
        if (!productVariationPayload) {
            return;
        }
        const variationTypes = getVariationTypesFromPayload(refractorPayload(productVariationPayload));
        const allCombinations = getAllCombinations(variationTypes);
        const userCombinations = getUserCombinations(refractorPayload(productVariationPayload));
        const missingCombinations = getMissingCombinations(allCombinations, userCombinations);
        if (missingCombinations.length > 0) {
            setMissingCombinationsList(missingCombinations);
            setMissingCombinationsModalOpen(true);
            return;
        }
        // --- Combination validation end ---
        const normalizedPayload = normalizeVariationValues(productVariationPayload);
        if (isEditMode) {
            editProductVariationApi(normalizedPayload);
        }
        else {
            addNewProductVariationApi();
        }
    };

    const handleProductSelection = (product: VariationDetailsItem, isChecked: boolean) => {
        setSelectedProducts(prevSelected => {
            if (isChecked) {
                const alreadyExists = prevSelected.some(p => p.cainzProductCode === product.cainzProductCode);
                return alreadyExists ? prevSelected : [...prevSelected, product];
            } else {
                return prevSelected.filter(p => p.cainzProductCode !== product.cainzProductCode);
            }
        });

        // Update the product variation payload
        setProductVariationPayload((prev) => {
            if (isChecked) {
                // Check if this product already exists in the payload
                const productExists = prev.productVariations.some(
                    p => p.cainzProductCode === product.cainzProductCode
                );
                
                if (productExists) {
                    // Product already exists, just update it
                    return {
                        ...prev,
                        productVariations: prev.productVariations.map(p => 
                            p.cainzProductCode === product.cainzProductCode
                                ? { ...p, postingStatus: 1 }
                                : p
                        )
                    };
                } else {
                    // Add new product to the payload
                    return {
                        ...prev,
                        productVariations: [
                            ...prev.productVariations,
                            {
                                cainzProductCode: product.cainzProductCode,
                                postingStatus: 1,
                                variations: []
                            }
                        ]
                    };
                }
            } else {
                // Remove product from the payload
                return {
                    ...prev,
                    productVariations: prev.productVariations.filter(
                        p => p.cainzProductCode !== product.cainzProductCode
                    )
                };
            }
        });
    };

    const searchProductToVariationDetailsType = (product: SearchedProduct): VariationDetailsItem => {
        return {
            cainzProductCode: product.cainzProductCode,
            postingStatus : 1,
            productName: product.productName,
            productCode: product.productCode,
            publicFlag: product.publicFlag,
            featuredImage: (isDemoUser || isSuperAdminDemoSeller) ?  `${product?.featuredImage}` :  `${product?.featuredImage}?date=${new Utility().dateTimeCache()}`,
            variationTypes: []
        };
    };

    useEffect(()=> {
        disableHandler();
    },[productVariationPayload,selectedProducts,checkedVariationType, fieldErrors, loading, showSkeleton, isEditMode, completedDataSet]);

    
    // TODO : Need to use disableHandler in the update button
    const disableHandler = () => {
        if (showSkeleton) return true;
    
        // Check if there are any visible products (not marked for deletion)
        const hasVisibleProducts = selectedProducts.some(p => p.postingStatus !== 9);
    
        // Check if at least one variation type is checked
        const hasCheckedVariations = checkedVariationType.length > 0;

        const isValidationErr = Object.values(fieldErrors).some(error => error === true);
        
        const isAllDeleted = completedDataSet.every((product : any) => product.postingStatus === 9);     
                
        // Simplified payload validation
        const isPayloadValid = productVariationPayload.productVariations.every((product ) => {
            if (product.postingStatus === 9) return true; // Skip validation for deleted products

            const validVariation = checkedVariationType.length == product?.variations?.length;
        
            return (
                product.variations && 
            Array.isArray(product.variations) && 
            product.variations.length === checkedVariationType.length &&
            product.variations.every((variation ) => 
                variation && validVariation &&
                variation.variationType && 
                variation.variationType.trim() !== "" && 
                variation.variationValue && 
                variation.variationValue.trim() !== "" &&
                (variation.displayType === "3" ? variation.variationValue.length <= 15 :  variation.variationValue.length <=50)
            )
            );
        });        

        if (isEditMode && isAllDeleted) {
            return false; // Allow saving in edit mode even if all products are deleted
        }


        return (
            loading ||
        !hasCheckedVariations || 
        !hasVisibleProducts || 
        !isPayloadValid || 
        isValidationErr
        );
    };

    
    const navigateToProductVariationList = () => {
        navigate(ROUTES.PRODUCT_VARIATION_LIST);
    };

    const deleteAllVariationHandler = () => {
        setShowDeleteModal(true);
    };

    const deleteDisableHandler = () => {
        if (completedDataSet.length === 0 ) {
            return true;
        }
        const productVariationPayload = convertToVariationPayloadRequest(completedDataSet);
        if (!productVariationPayload) {
            return true;
        }

        const visibleProducts = productVariationPayload.productVariations.filter((item) => item.postingStatus!==9);
        if(loading || visibleProducts.length === 0 )
            return true;

        if( loading || !isEditMode && selectedProducts.length === 0 ){
            return true;
        }
        if( loading || productVariationPayload.productVariations.length === 0)
            return true;
    };

    const confirmDelete = () => {
        setSelectedProducts([]);
        setVariations(initialVariationTypes);
        setCheckedVariationType([]);
        setEditModeInitialRender(true);
        showSnackbar(t("product_variation_list.product_delete"), true);
        if(!isEditMode){
            showSnackbar(t("product_variation_list.product_delete"), true);
            setProductVariationPayload({
                faceProductCode : "",
                productVariations : []
            });
        }else {
            const deletedProduct : VariationPayloadRequest = {
                faceProductCode: previousProducts[0].cainzProductCode,
                productVariations: previousProducts.map((product:any) => ({
                    cainzProductCode : product.cainzProductCode,
                    postingStatus : 9,
                    variations : product.variationTypes.map((variation:any) => ({
                        displayOrder: variation.displayOrder,
                        variationType: variation.variationType,
                        variationValue: variation.variationValue,
                        displayType: variation.displayType,
                    }))
                }))
            };
            setProductVariationPayload(deletedProduct);
        }
        setShowDeleteModal(false);
    };

    const cancelDelete = () => {
        setShowDeleteModal(false);
    };

    const handleApiCall = ()=>{
        if(search.trim().length > 0){
            setShowDropdown(true);
            productData(currentPage, limit);
        }
    };

    // Utility to generate all possible combinations from variation types
    const getAllCombinations = (variationTypes: { [key: string]: string[] }): any => {
        const keys = Object.keys(variationTypes);
        if (keys.length === 0) return [];
        let result: any[] = [{}];
        for (const key of keys) {
            const temp: any[] = [];
            for (const obj of result) {
                for (const value of variationTypes[key]) {
                    temp.push({ ...obj, [key.normalize("NFKC").trim()]: value.normalize("NFKC").toLowerCase().trim() });
                }
            }
            result = temp;
        }
        return result;
    };

    const getMissingCombinations = (allCombinations: any[], userCombinations: any[]): any[] => {
        const result: any[] = [];

        for (const comb of allCombinations) {
            const isExisting = userCombinations.some(({ normalized }) =>
                Object.keys(comb).every(key =>
                    normalized[key] === comb[key]
                )
            );

            if (!isExisting) {
            // Try to build original-value version from available user entries
                const originalComb: any = {};
                Object.keys(comb).forEach(key => {
                // Try to find matching original for that key/value
                    const match = userCombinations.find(({ normalized }) => normalized[key] === comb[key]);
                    if (match) {
                        originalComb[key] = match.original[key] || comb[key]; // fallback to normalized if needed
                    } else {
                        originalComb[key] = comb[key]; // fallback
                    }
                });

                result.push(originalComb);
            }
        }

        return result;
    };

    const getVariationTypesFromPayload = (payload: VariationPayloadRequest): { [key: string]: string[] } => {
        const variationTypeMap: { [key: string]: Set<string> } = {};
        payload.productVariations.forEach(product => {
            if (product.postingStatus === 9) return; // skip deleted
            product.variations.forEach(variation => {
                const typeKey = variation.variationType.normalize("NFKC").trim();
                const value = variation.variationValue.normalize("NFKC").toLowerCase().trim();
                if (!variationTypeMap[typeKey]) {
                    variationTypeMap[typeKey] = new Set();
                }
                variationTypeMap[typeKey].add(value);
            });
        });
        return Object.fromEntries(
            Object.entries(variationTypeMap).map(([k, v]) => [k, Array.from(v)])
        );
    };

    const getUserCombinations = (payload: VariationPayloadRequest): any[] =>{
        return payload.productVariations
            .filter(product => product.postingStatus !== 9)
            .map(product => {
                const normalized: any = {};
                const original: any = {};
                product.variations.forEach(variation => {
                    const key = variation.variationType;
                    const value = variation.variationValue;

                    const normalizedKey = key.normalize("NFKC").trim();
                    const normalizedValue = value.normalize("NFKC").toLowerCase().trim();

                    normalized[normalizedKey] = normalizedValue;
                    original[normalizedKey] = value; // map original value by normalized key
                });
                return { normalized, original };
            });
    };

    return (
        <Grid className="main_page_grid">
            {/* Header Section */}
            <Grid item xs={12} sm={12} md={12} lg={12} className="heading_grid" sx={{ marginBottom: { xs: 2, sm: 0 } }}>
                <Grid container alignItems={"center"}>
                    <Grid item xs={12} sm={5} md={6} lg={6}>
                        <HeaderTitle title={t("product_variation_list.add_variation")} />
                    </Grid>
                </Grid>
            </Grid>
            {/* header */}
            <Grid container sx={{ justifyContent: "space-between" }} px={3}>
                {/* Search Section */}
                <Grid item xs={12} sm={6} md={8} lg={9}>
                    <Box ref={dropdownRef} style={{ position: "relative", width: "100%" }}>
                        <TextField
                            label={t("product_variation_list.search_place_holder")}
                            onChange={handleProductsDetailsSearch}
                            value={search}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {
                                            search.trim().length > 0 && (
                                                <IconButton onClick={() => {
                                                    setSearch("");
                                                    setShowDropdown(false);
                                                }}>
                                                    <CloseIcon />
                                                </IconButton>
                                            )
                                        }
                                        <IconButton onClick={handleApiCall}>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            
                            variant="outlined"
                            fullWidth
                            size="small" />
                        {(search && showDropdown) && (
                            <Grid sx={{ 
                                position: "relative",
                                width: "100%",
                            }}>
                                <Paper 
                                    elevation={3} 
                                    className="dropdown" 
                                    sx={{ 
                                        position: "absolute",
                                        width: "100%",
                                        zIndex: 9999,
                                        minHeight:"50px",
                                        maxHeight: "250px",
                                        border : "1px solid #b1a7a7",
                                        overflowY: "auto"
                                    }}
                                >
                                    <List>
                                        {
                                            searchSkeleton ? (
                                                Array.from({ length: 1 }).map((_, index) => (
                                                    <ListItem key={index}>
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width="100%"
                                                            height={40}
                                                        />
                                                    </ListItem>
                                                ))
                                            ) : (
                                                searchedProducts.length > 0 ?
                                                    (searchedProducts.map((product) => (
                                                        <ListItem key={product.id} button
                                                            onClick={() => handleProductSelection(searchProductToVariationDetailsType(product), !selectedProducts.some(p => p.cainzProductCode === product.cainzProductCode))}
                                                            sx={{
                                                                display: "flex",
                                                                alignItems:"flex-start",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                overflowWrap: "break-word",
                                                                maxWidth: "1500px"
                                                            }} >
                                                            <Checkbox
                                                                checked={selectedProducts.some(p => p.cainzProductCode === product.cainzProductCode)}
                                                                onChange={(e) => handleProductSelection(searchProductToVariationDetailsType(product), e.target.checked)} />
                                                            <ListItemText
                                                                primary={`${product?.productName} (${product?.productCode})`}
                                                                sx={{
                                                                    whiteSpace: "normal",
                                                                    wordBreak: "break-word",
                                                                    overflowWrap: "break-word",
                                                                    maxWidth: "100%"
                                                                }} />
                                                        </ListItem>
                                                    )))
                                                    :
                                                    (
                                                        <ListItem sx={{ justifyContent: "center" }}>
                                                            <Typography>{t("product_variation_list.no_data_found")}</Typography>
                                                        </ListItem>
                                                    )
                                            )
                                        }
                                    </List>
                                </Paper>
                            </Grid>
                        )}
                    </Box>
                </Grid>
                {/* Save and Back Button Section */}
                <Grid item xs={12} sm={6} md={4} lg={3} container spacing={2} sx={{ display: "flex", justifyContent: { xs: "space-between", sm: "end", md: "end" }, mt: { xs: 1, sm: -2, md: -2 }, alignItems: "center",gap:4 }} pt={0}>
                    <Grid item sx={{ zIndex: { xs: -1, sm: 0, md: 0, lg: 0 } }}>
                        <CommonButton sx={{textTransform: "capitalize"}} loading={loading} route={window.location.pathname} functionToExecute={deleteAllVariationHandler} className="wd_100" btnName={t("product_variation_list.delete_all")} disableCondition={deleteDisableHandler()} />
                    </Grid>
                    <Grid item>
                        <CommonButton sx={{textTransform: "capitalize"}} loading={loading}  route={window.location.pathname} functionToExecute={saveButtonClickhandler} className="wd_100" btnName= {!isEditMode ? t("product_variation_list.save") : t("product_variation_list.update")} disableCondition={disableHandler()} />
                    </Grid>
                    <Grid item sx={{ zIndex: { xs: -1, sm: 0, md: 0, lg: 0 } }}>
                        <Button className="wd_100" sx={{textTransform: "capitalize"}} variant="contained" color="primary"  onClick={navigateToProductVariationList}>
                            {t("product_variation_list.back")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <EditVariation
                previousProducts={previousProducts}
                productVariationPayload={productVariationPayload}
                setProductVariationPayload={setProductVariationPayload}
                isSaveEnabled={isSaveEnabled}
                setIsSaveEnabled={setIsSaveEnabled}
                selectedProducts={selectedProducts}
                setSelectedProducts={setSelectedProducts}
                showSkeleton={showSkeleton}
                showSnackbar={showSnackbar}
                validator={validator}
                fieldErrors={fieldErrors}
                setFieldErrors={setFieldErrors}
                isEditMode={isEditMode}
                variations={variations}
                setVariations={setVariations}
                initialVariationTypes={initialVariationTypes} 
                setCheckedVariationType={setCheckedVariationType} 
                checkedVariationType={checkedVariationType}
                setEditModeInitialRender={setEditModeInitialRender}
                editModeInitialRender={editModeInitialRender}
                currentProduct={currentProduct}
                completedDataSet={completedDataSet}
                setCompletedDataSet={setCompletedDataSet}
            />
            <ConfirmationModal
                open={showDeleteModal}
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
                title=""
                message={
                    <Box style={{display : "flex",flexDirection : "column",color:"black",textAlign : "left"}}>
                        <Box>{t("product_variation_list.confirm_message_all_variation")}</Box>
                        {
                            isEditMode ? 
                                <Box>{t("product_variation_list.confirm_message_actual_reflection_update")}</Box> : 
                                <Box>{t("product_variation_list.confirm_message_actual_reflection_save")}</Box>
                        }
                    </Box>
                }
                confirmText={t("product_variation_list.yes")}
                cancelText={t("product_variation_list.no")}
            />
            <ConfirmationModal
                open={missingCombinationsModalOpen}
                onConfirm={() => setMissingCombinationsModalOpen(false)}
                onCancel={() => setMissingCombinationsModalOpen(false)}
                title={""}
                message={
                    <Box>
                        <Box style={{ marginBottom: 8, fontWeight: 600,textAlign:"left" }}>
                            {t("product_variation_list.missing_combinations_instruction1")}
                            <br/>
                            {t("product_variation_list.missing_combinations_instruction2")}
                        </Box>
                        <Box >
                            {missingCombinationsList.map((comb, idx) => {
                                const entries = Object.entries(comb);
                                const text = entries.map(([k, v]) => `${k} ：${v}`).join(t("product_variation_list.and")||"");
                                return (
                                    <Box key={idx} sx={{textAlign:"left" }}>
                                        {t("product_variation_list.missing_combinations_item", { combination: text })}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                }
                confirmText=""
                cancelText=""
                showCloseIcon={true}
            />
        </Grid>
    );
};

export default AddVariation;
